import storage from 'local-storage-fallback';

const AccessTokenKey = 'access_token';

export const localStorageService = ({
  getToken: () => storage.getItem(AccessTokenKey),
  setToken: (token: string) => storage.setItem(AccessTokenKey, token),
  clearToken: () => storage.removeItem(AccessTokenKey),
});
